module.exports = __webpack_public_path__ + "img/slide4.4c1042c3.webp";